/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Full Stack Developer",
  title: "Привет, я Александр!",
  subTitle: emoji(
    "Опытный full-stack разработчик, специализирующийся на сложных приложениях, включая системы компьютерного зрения и машинного обучения. Работаю напрямую с заказчиками без посредников, обеспечивая масштабируемость, производительность и безопасность решений. 🚀"
  ),
  displayGreeting: true
};

const socialMediaLinks = {
  display: false
};

const skillsSection = {
  title: "Технические навыки",
  subTitle: "ПОЛНЫЙ СТЕК РАЗРАБОТКИ С ФОКУСОМ НА ML И КОМПЬЮТЕРНОЕ ЗРЕНИЕ",
  skills: [
    emoji("⚡ Разработка сложных full-stack приложений с акцентом на масштабируемость и производительность"),
    emoji("⚡ Системы компьютерного зрения и машинного обучения для обработки видео в реальном времени"),
    emoji("⚡ Интеграция ML-моделей в production-среду, оптимизация производительности и безопасности"),
    emoji("⚡ UI/UX-дизайн интерфейсов, проектирование wireframes и прототипов в Figma"),
    emoji("⚡ Графический дизайн: создание макетов, иконок и ассетов с учетом типографики и цветовой теории")
  ],

  softwareSkills: [
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fab fa-js-square"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "figma",
      fontAwesomeClassname: "fab fa-figma"
    }
  ],
  display: true
};

const educationInfo = {
  display: false
};

const techStack = {
  viewSkillBars: true,
  experience: [
    {
      Stack: "Backend & ML",
      progressPercentage: "95%"
    },
    {
      Stack: "Frontend & Design",
      progressPercentage: "90%"
    },
    {
      Stack: "Computer Vision",
      progressPercentage: "85%"
    }
  ],
  displayCodersrank: false
};

const workExperiences = {
  display: false
};

const openSource = {
  display: false
};

const bigProjects = {
  title: "Ключевые проекты",
  subtitle: "РЕАЛИЗОВАННЫЕ РЕШЕНИЯ С ФОКУСОМ НА ML И КОМПЬЮТЕРНОЕ ЗРЕНИЕ",
  projects: [
    {
      projectName: "E-commerce платформа с персонализацией",
      projectDesc: "Полнофункциональная платформа электронной коммерции с системой персонализации на основе ML-алгоритмов для рекомендаций товаров",
      footerLink: []
    },
    {
      projectName: "Система контроля качества на базе YOLO",
      projectDesc: "Система автоматического контроля качества продукции с использованием YOLO для детекции дефектов в реальном времени",
      footerLink: []
    },
    {
      projectName: "Мобильное фитнес-приложение (React Native)",
      projectDesc: "Кроссплатформенное мобильное приложение для фитнеса с трекингом активности и персонализированными программами тренировок",
      footerLink: []
    },
    {
      projectName: "Интеллектуальное видеонаблюдение с ML",
      projectDesc: "Система видеонаблюдения с распознаванием объектов, лиц и жестов в реальном времени на базе PyTorch и OpenCV",
      footerLink: []
    },
    {
      projectName: "Автоматизация производства с обработкой видео",
      projectDesc: "Система автоматизации производственных процессов с компьютерным зрением для контроля качества и оптимизации производства",
      footerLink: []
    },
    {
      projectName: "Система распознавания документов с OCR и ML",
      projectDesc: "Интеллектуальная система автоматического распознавания и обработки документов с использованием Tesseract OCR и машинного обучения для извлечения структурированных данных",
      footerLink: []
    },
    {
      projectName: "Платформа аналитики данных в реальном времени",
      projectDesc: "Full-stack решение для сбора, обработки и визуализации больших объемов данных с использованием асинхронных API и интерактивных дашбордов",
      footerLink: []
    },
    {
      projectName: "Система распознавания лиц и биометрии",
      projectDesc: "Безопасная система идентификации пользователей на основе распознавания лиц с использованием DLib и PyTorch, интегрированная с веб-приложением",
      footerLink: []
    }
  ],
  display: true
};

const achievementSection = {
  display: false
};

const blogSection = {
  display: false
};

const talkSection = {
  display: false
};

const podcastSection = {
  display: false
};

const resumeSection = {
  display: false
};

const contactInfo = {
  title: "Свяжитесь со мной",
  subtitle:
    "Обсудить проект или просто поздороваться? Я открыт для общения.",
  number: "",
  email_address: ""
};

const twitterDetails = {
  userName: "twitter",
  display: false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
